import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./lib/auth";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import FindRestaurants from "./pages/FindRestaurants";
import Leads from "./pages/Leads";
import LeadReport from "./pages/LeadReport";
import Jobs from "./pages/Jobs";
import PrintReport from "./pages/PrintReport";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminServices from "./pages/admin/AdminServices";
import AdminIntegrations from "./pages/admin/AdminIntegrations";
import AdminUsage from "./pages/admin/AdminUsage";

function Protected({ children, admin }) {
  const { user } = useAuth();
  if (user === null) return <div className="p-10 text-sm text-slate-500" data-testid="auth-loading">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function App() {
  useEffect(() => {
    document.title = "360RGE Restaurant Lead Finder";
  }, []);
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/print/:id" element={<Protected><PrintReport /></Protected>} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route index element={<FindRestaurants />} />
            <Route path="leads" element={<Leads />} />
            <Route path="leads/:id" element={<LeadReport />} />
            <Route path="jobs" element={<Jobs />} />
            <Route path="admin/users" element={<Protected admin><AdminUsers /></Protected>} />
            <Route path="admin/services" element={<Protected admin><AdminServices /></Protected>} />
            <Route path="admin/integrations" element={<Protected admin><AdminIntegrations /></Protected>} />
            <Route path="admin/usage" element={<Protected admin><AdminUsage /></Protected>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
